import React from 'react';
import cx from 'clsx';
import Color from 'color';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import { useCoverCardMediaStyles } from '@mui-treasury/styles/cardMedia/cover';
import { Row, Item } from '@mui-treasury/components/flex';
import Paper from '@material-ui/core/Paper';

import { Link as RouterLink } from 'react-router-dom';


const useStyles = makeStyles(({ palette }) => ({
  color: ({ color }: { color: string }) => ({
    '&:before': {
      backgroundColor: Color(color)
        .darken(0.3)
        .desaturate(0.2)
        .toString(),
    },
  }),
  root: {
    position: 'relative',
    borderRadius: 4,
    minWidth: 100,
    minHeight:300,
    '&:before': {
      transition: '0.2s',
      position: 'absolute',
      width: '100%',
      height: '100%',
      content: '""',
      display: 'block',
      borderRadius: 4,
      zIndex: 0,
      bottom: 0,
    },
    '&:hover': {
      '&:before': {
        bottom: -4,
      }
    },
  },
  cover: {
      borderRadius: 4,
  },
  content: ({ color }: { color: string }) => ({
    position: 'relative',
    zIndex: 1,
    borderRadius: 4,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: 0,
      top: '50%',
      zIndex: 0,
      width: '100%',
      height: '50%',
      clipPath:
        'polygon(0% 100%, 0% 35%, 0.3% 33%, 1% 31%, 1.5% 30%, 2% 29%, 2.5% 28.4%, 3% 27.9%, 3.3% 27.6%, 5% 27%,95% 0%,100% 0%, 100% 100%)',
      borderRadius: 4,
      background: `linear-gradient(to top, ${color}, ${Color(color)
        .rotate(24)
        .lighten(0.12)})`,
    },
  }),
  title: {
    fontSize: '1.25rem',
    color: '#fff',
    margin: 0,
  },
  team: {
    fontSize: '0.75rem',
    color: '#dcdcde',
  },
}));

const CustomCard = ({ styles, cover, logo, title, brand, date, to }) => {
  const mediaStyles = useCoverCardMediaStyles();
  const renderLink = React.useMemo(
    () => React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
    [to],
  );

  return (
    <Paper style={{ textDecoration: 'none' }} component={renderLink}>
        <Box className={cx(styles.root, styles.color)} pt={10}>
          <CardMedia image={cover} className={styles.cover} classes={mediaStyles} />
          <Box className={styles.content} pt={20} >
            <Box position={'relative'} zIndex={1}>
              <Row pl={2} gap={0}>
                <Item position={'bottom'}>
                  <div  className={styles.title}>{title}</div>
                </Item>
              </Row>
              <Row pl={2} pb={2} alignItems={'center'}>
                <Item position={'bottom'}>
                  <div className={styles.team}>{brand}</div>
                </Item>
              </Row>
            </Box>
          </Box>
        </Box>
      </Paper>

  );
};


/*
<Grid
  style={{ padding: 5 }}
  classes={gridStyles}
  wrap={'nowrap'}
  container
  spacing={2}
>
*/

export const CardMenu = React.memo(function HighlightCard() {
  const styles1 = useStyles({ color: '#424242' });
  //const styles2 = useStyles({ color: '#5357ce' });
  //const styles3 = useStyles({ color: '#aa559d' });
  //const styles4 = useStyles({ color: '#72af50' });
  //const styles5 = useStyles({ color: '#b78b48' });
  //const styles6 = useStyles({ color: '#4f72b0' });

  return (

      <Grid
        container
        spacing={2}
      >
        <Grid item xs={12} s={6} md={4} lg={4}>
          <CustomCard
            styles={styles1}
            brand={'LEARN MORE'}
            cover={
              'https://images.pexels.com/photos/357514/pexels-photo-357514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            }
            title={'Documentation'}
            to={'/documentation'}
          />
        </Grid>
        <Grid item xs={12} s={6} md={4} lg={4}>
          <CustomCard
            styles={styles1}
            brand={'LEARN MORE'}
            cover={
              'https://images.pexels.com/photos/132340/pexels-photo-132340.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            }
            title={'Container Audit'}
            to={'/audit'}
          />
        </Grid>
        <Grid item xs={12} s={6} md={4} lg={4}>
          <CustomCard
            styles={styles1}
            brand={'LEARN MORE'}
            cover={
              'https://images.pexels.com/photos/262488/pexels-photo-262488.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            }
            title={'Network Visualization'}
            to={'/network'}
          />
        </Grid>
        <Grid item xs={12} s={6} md={4} lg={4}>
          <CustomCard
            styles={styles1}
            brand={'LEARN MORE'}
            cover={
              'https://images.pexels.com/photos/159206/mixing-table-mixing-music-musician-159206.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            }
            title={'Utilization'}
            to={'/treemap'}
          />
        </Grid>
        <Grid item xs={12} s={6} md={4} lg={4}>
          <CustomCard
            styles={styles1}
            brand={'LEARN MORE'}
            cover={
              'https://images.pexels.com/photos/187041/pexels-photo-187041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            }
            title={'Release History'}
            to={'/history'}
          />
        </Grid>
        <Grid item xs={12} s={6} md={4} lg={4}>
          <CustomCard
            styles={styles1}
            brand={'LEARN MORE'}
            cover={
              'https://images.pexels.com/photos/356079/pexels-photo-356079.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
            }
            title={'Feature Requests'}
            to={'/contact-us'}
          />
        </Grid>
      </Grid>
  );
});

export default CardMenu;
